import React from "react";
import { useParams } from "react-router-dom";
import { DefaultPageLayout } from "../../../../ui/layouts/DefaultPageLayout";
import { ApplyPivotViewFlow } from "./pivotBuilder/components/ApplyPivotViewFlow";

export const ApplyPivotViewPage: React.FC = () => {
  const { viewId } = useParams<{ viewId: string }>();

  if (!viewId) {
    return (
      <DefaultPageLayout>
        <div className="flex items-center justify-center h-full">
          <p className="text-body font-body text-error-700">
            Invalid pivot view ID. Please select a view from the library.
          </p>
        </div>
      </DefaultPageLayout>
    );
  }

  return (
    <DefaultPageLayout>
      <ApplyPivotViewFlow viewId={viewId} />
    </DefaultPageLayout>
  );
};

